import * as DateHelper from "./date-helper"
export type InstallmentsStatusType =
  | "EXTERNAL_RECEIVABLE"
  | "RECEIVABLE"
  | "RECEIVED"
  | "CANCELLED"
  | "FUTURE"
  | "AUTHORIZED"
  | "PAYMENT_ERROR"
export const installmentStatusObject = {
  EXTERNAL_RECEIVABLE: {
    bgColor: "#9CA3AF",
    text: "Pendente",
  },
  RECEIVABLE: {
    bgColor: "#9CA3AF",
    text: "Pendente",
  },
  RECEIVED: {
    bgColor: "#4ADE80",
    text: "Pago",
  },
  CANCELLED: {
    bgColor: "#F87171",
    text: "Cancelado",
  },
  FUTURE: {
    bgColor: "#FACC15",
    text: "Futuro",
  },
  AUTHORIZED: {
    bgColor: "#0D6EFD",
    text: "Autorizado",
  },
  PAYMENT_ERROR: {
    bgColor: "#F87171",
    text: "Erro de pagamento",
  },
}
export const getStatusInfo = (status: keyof typeof installmentStatusObject) => {
  return installmentStatusObject[status]
}
export const interpolate = (
  template: string,
  params: Record<string, string>,
) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    const value = params[key.trim()]
    return value !== undefined ? value : ""
  })
}
export { DateHelper }
